// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const ScrollAreaContract = contract({
  name: "ScrollArea",
  description: "Bounded content that needs custom scroll chrome — sidebars with long item lists, chat transcripts, table panels inside a dashboard, anywhere the OS scrollbar would feel out of place against the design tokens. The wrapping element has to have a height constraint (`h-`, `max-h-`, or grid row sizing) or nothing scrolls — scroll-area can't infer a bound on its own. For body-level scrolling, leave the document to the browser.",
  import: "@gradeui/ui",
  aliases: ["scroll area","scroll container","custom scrollbar","sidebar scroll","panel scroll","scroll view","scrollview","react native scrollview"],
  subcomponents: ["ScrollBar"],
  composesWith: ["Card (long card body)","AppShellNav (long sidebar)","Sheet (long modal body)","Table (sticky-header scrolling list)"],
  styleDefaults: {"ScrollArea":"relative overflow-hidden","ScrollBar":"flex touch-none select-none transition-colors"},
  props: {
  "type": {
      schema: z.enum(["auto", "always", "scroll", "hover"]).optional(),
      design: "knob",
      description: "when the scrollbar shows",
  },
  "scrollHideDelay": {
      schema: z.number().optional(),
      design: "knob",
      description: "ms before \"scroll\"/\"hover\" scrollbars fade",
  },
  "dir": {
      schema: z.enum(["ltr", "rtl"]).optional(),
      design: "plumbing",
  },
  "className": {
      schema: z.string().optional(),
      design: "plumbing",
      description: "set a height/max-height here, otherwise nothing scrolls",
  },
  "orientation": {
      schema: z.enum(["vertical", "horizontal"]).optional(),
      design: "knob",
      default: "vertical",
  },
  },
});
